// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamProperties-module__root__34uEg","label":"StreamProperties-module__label__2aNL8","first-label":"StreamProperties-module__first-label__tX7i7"};